import useDropTypeFromPath from './useDropTypeFromPath';

export default function useDropShareUrl(dropId?: number) {
  const dropType = useDropTypeFromPath();
  return `/d/${dropType}/${dropId}`;
}
